import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAtomAnimationsCircleLoader, LazyAtomAnimationsEqualiser, LazyAtomAnimationsRecommendationEqualiser, LazyAtomBasketNumber, LazyAtomBrandConcertgebouwLogo, LazyAtomBrandConcertgebouwLyre, LazyAtomBrandDiscoveryTitleDutch, LazyAtomBrandLyreBackgroundThemed, LazyAtomHeadingContentItem, LazyAtomHeadingDetailPageMain, LazyAtomHeadingPageSection, LazyAtomHeadingPageSectionLanding, LazyAtomIcon, LazyAtomIconArrowDown, LazyAtomIconArrowLeft, LazyAtomIconArrowRight, LazyAtomIconArrowUp, LazyAtomIconBasket, LazyAtomIconBell, LazyAtomIconBirthdayCake, LazyAtomIconBookmark, LazyAtomIconBookmarkFilled, LazyAtomIconCalendar, LazyAtomIconCamera, LazyAtomIconCart, LazyAtomIconCheck, LazyAtomIconCheckmark, LazyAtomIconChevronDown, LazyAtomIconChevronLeft, LazyAtomIconChevronRight, LazyAtomIconChevronUp, LazyAtomIconCircledCheck, LazyAtomIconCircledCheckFilled, LazyAtomIconCircledCrossFilled, LazyAtomIconCircledFacebook, LazyAtomIconCircledInstagram, LazyAtomIconCircledSpotify, LazyAtomIconCircledTwitter, LazyAtomIconCircledX, LazyAtomIconCircledYoutube, LazyAtomIconCross, LazyAtomIconFacebookF, LazyAtomIconGear, LazyAtomIconHamburger, LazyAtomIconInstagram, LazyAtomIconMail, LazyAtomIconMicrophone, LazyAtomIconMinus, LazyAtomIconMusicNote, LazyAtomIconPdfFile, LazyAtomIconPencil, LazyAtomIconPhone, LazyAtomIconPiggyBank, LazyAtomIconPile, LazyAtomIconPlay, LazyAtomIconPlus, LazyAtomIconPowerSwitch, LazyAtomIconSearch, LazyAtomIconShort, LazyAtomIconTranslate, LazyAtomIconTwitter, LazyAtomIconWhatsApp, LazyAtomIconX, LazyAtomIconAppApp, LazyAtomIconAppArchive, LazyAtomIconAppBullhorn, LazyAtomIconAppCheckboxChecked, LazyAtomIconAppCheckboxUnchecked, LazyAtomIconAppCircledExclamationMark, LazyAtomIconAppClock, LazyAtomIconAppDigital, LazyAtomIconAppEuro, LazyAtomIconAppExternal, LazyAtomIconAppFilter, LazyAtomIconAppHat, LazyAtomIconAppLoader, LazyAtomIconAppLocationMarker, LazyAtomIconAppLock, LazyAtomIconAppPause, LazyAtomIconAppPauseRecommendation, LazyAtomIconAppPerson, LazyAtomIconAppPlay, LazyAtomIconAppPlayRecommendation, LazyAtomIconAppPlayTriangle, LazyAtomIconAppPreludium, LazyAtomIconAppSearch, LazyAtomIconAppSignpost, LazyAtomIconAppSpeaker, LazyAtomIconAppSpeakerMuted, LazyAtomIconAppWebsitevanhetjaarDark, LazyAtomIconAppWebsitevanhetjaarLight, LazyAtomIconAppYoutube, LazyAtomLink, LazyAtomLogosAmsterdamsFondsVoorDeKunst, LazyAtomLogosFpk, LazyAtomLogosHetConcertgebouwFonds, LazyAtomLogosVanLanschot, LazyAtomLogosVriendenloterij, LazyAtomNewsletter, LazyDebugDump, LazyFormieFieldAgree, LazyFormieFieldCheckboxes, LazyFormieFieldDate, LazyFormieFieldDropdown, LazyFormieFieldEmail, LazyFormieFieldEntries, LazyFormieFieldFileUpload, LazyFormieFieldGroup, LazyFormieFieldHeading, LazyFormieFieldHidden, LazyFormieFieldHtml, LazyFormieFieldMultiLineText, LazyFormieFieldName, LazyFormieFieldNumber, LazyFormieFieldPhone, LazyFormieFieldRadio, LazyFormieFieldRepeater, LazyFormieFieldSection, LazyFormieFieldSingleLineText, LazyFormieForm, LazyFormieRows, LazySmoothReflow, LazyVideoBackground, LazyMoleculeABTestWrapper, LazyMoleculeAudioWorks, LazyMoleculeAudioWorksV2, LazyMoleculeButton, LazyMoleculeButtonBack, LazyMoleculeButtonBreadcrumbBack, LazyMoleculeButtonMobileLyre, LazyMoleculeButtonSearchFilter, LazyMoleculeButtonShort, LazyMoleculeButtonToggle, LazyMoleculeCardAudioPlayerOverlay, LazyMoleculeCardBanner, LazyMoleculeCardCollection, LazyMoleculeCardCover, LazyMoleculeCardDiscoverLandscape, LazyMoleculeCardDiscoverPortrait, LazyMoleculeCardEducation, LazyMoleculeCardEventAndSeries, LazyMoleculeCardEventCompact, LazyMoleculeCardEventMedia, LazyMoleculeCardMenuCategory, LazyMoleculeCardOverview, LazyMoleculeCardRecommendationQuestion, LazyMoleculeCardRecommendationSuggestion, LazyMoleculeCardResult, LazyMoleculeCardResultInline, LazyMoleculeCarousel, LazyMoleculeCarouselVideo, LazyMoleculeCollage, LazyMoleculeComponentJoin, LazyMoleculeDatepicker, LazyMoleculeDatepickerLegacy, LazyMoleculeDiscoveryCarousel, LazyMoleculeDiscoveryShort, LazyMoleculeEducationProductionDetailPageBody, LazyMoleculeEducationProductionOrderInfoRow, LazyMoleculeEducationProductionPageInfoData, LazyMoleculeEventDetailOrderButtons, LazyMoleculeEventDetailPageAdditionalInfoV2, LazyMoleculeEventDetailPageAudioV2, LazyMoleculeEventDetailPageBackButton, LazyMoleculeEventDetailPageBodyV2, LazyMoleculeEventDetailPageDiscover, LazyMoleculeEventDetailPageHeaderV2, LazyMoleculeEventDetailPageInfoAndTicketsV2, LazyMoleculeEventDetailPageInfoData, LazyMoleculeEventDetailPageInfoDataMobileSticky, LazyMoleculeEventDetailPageInfoDataV2, LazyMoleculeEventDetailPageMedia, LazyMoleculeEventDetailPageNeta, LazyMoleculeEventDetailPageOtherDates, LazyMoleculeEventDetailPageSideProgramV2, LazyMoleculeEventDetailPageTitleV2, LazyMoleculeFacet, LazyMoleculeFoldoutItem, LazyMoleculeFoldoutList, LazyMoleculeInfoPanel, LazyMoleculeInputWithIcon, LazyMoleculeMaskVisual, LazyMoleculeMatrix, LazyMoleculeMatrixAudio, LazyMoleculeMatrixBanner, LazyMoleculeMatrixCarousel, LazyMoleculeMatrixCollectionShelf, LazyMoleculeMatrixCookieDeclaration, LazyMoleculeMatrixDiscoveries, LazyMoleculeMatrixDiscoveryShelf, LazyMoleculeMatrixEvents, LazyMoleculeMatrixFoldout, LazyMoleculeMatrixForm, LazyMoleculeMatrixHubspotForm, LazyMoleculeMatrixImage, LazyMoleculeMatrixNewsletter, LazyMoleculeMatrixOverviewSectionEntries, LazyMoleculeMatrixSearchEvents, LazyMoleculeMatrixText, LazyMoleculeMatrixVideo, LazyMoleculeMatrixVriendenLoterijVipCard, LazyMoleculeMatrixWidget, LazyMoleculeNotification, LazyMoleculeOverlayMatrix, LazyMoleculeOverlayPanel, LazyMoleculeOverlayStickyButton, LazyMoleculePicture, LazyMoleculeProgram, LazyMoleculeProgramEventDetail, LazyMoleculeRecaptchaDisclaimer, LazyMoleculeRecommendationProgressBar, LazyMoleculeRecommendationQuestion, LazyMoleculeShelf, LazyMoleculeSkiplink, LazyMoleculeVideo, LazyOrganismControlPanel, LazyOrganismControlPanelFoldout, LazyOrganismDesktopMenu, LazyOrganismFooter, LazyOrganismHomeBanners, LazyOrganismHomeDiscovery, LazyOrganismHomeEvents, LazyOrganismHomeHeader, LazyOrganismHomeNewsletter, LazyOrganismHomeOverview, LazyOrganismHomeSearchConcertsControl, LazyOrganismHomeSearchConcertsV1, LazyOrganismLoaderFromUri, LazyOrganismMobileMenu, LazyOrganismModal, LazyOrganismOverviewHeaderAndFiltersControl, LazyOrganismOverviewHeaderAndFiltersV1, LazyOrganismPageOverlay, LazyOrganismPageSectionContent, LazyOrganismPagination, LazyOrganismPaginationV2, LazyOrganismRecommendationLoadingPage, LazyOrganismRecommendationQuestionnaire, LazyOrganismRecommendationRestartBlock, LazyOrganismRecommendationStartPage, LazyOrganismRecommendationSuggestMailBlock, LazyOrganismRecommendationSuggestSidebar, LazyOrganismRecommendationSuggestTopEvents, LazyOrganismRecommendationSuggestionBottomEvents, LazyOrganismRecommendationSuggestionPage, LazyOrganismSearchHeader, LazyOrganismTixState, LazyTemplateBase, LazyTemplateCampaignDetail, LazyTemplateDiscoveryCollectionDetail, LazyTemplateDiscoveryDetail, LazyTemplateDiscoveryOverview, LazyTemplateDiscoverySearchOverview, LazyTemplateEducationOverview, LazyTemplateEducationProductionDetail, LazyTemplateEducationProductionOverview, LazyTemplateEducationUserUpdateForm, LazyTemplateError, LazyTemplateEventDetailV2, LazyTemplateEventOverview, LazyTemplateFavoritePage, LazyTemplateHome, LazyTemplateOverview, LazyTemplatePageDetail, LazyTemplatePressDetail, LazyTemplatePressOverview, LazyTemplateRecommendationDetail, LazyTemplateRecommendationDetailV2, LazyTemplateSearch, LazyTemplateSeriesDetail, LazyTemplateSeriesOverview, LazyTemplateUnknownPage } from '#components'
const lazyGlobalComponents = [
  ["AtomAnimationsCircleLoader", LazyAtomAnimationsCircleLoader],
["AtomAnimationsEqualiser", LazyAtomAnimationsEqualiser],
["AtomAnimationsRecommendationEqualiser", LazyAtomAnimationsRecommendationEqualiser],
["AtomBasketNumber", LazyAtomBasketNumber],
["AtomBrandConcertgebouwLogo", LazyAtomBrandConcertgebouwLogo],
["AtomBrandConcertgebouwLyre", LazyAtomBrandConcertgebouwLyre],
["AtomBrandDiscoveryTitleDutch", LazyAtomBrandDiscoveryTitleDutch],
["AtomBrandLyreBackgroundThemed", LazyAtomBrandLyreBackgroundThemed],
["AtomHeadingContentItem", LazyAtomHeadingContentItem],
["AtomHeadingDetailPageMain", LazyAtomHeadingDetailPageMain],
["AtomHeadingPageSection", LazyAtomHeadingPageSection],
["AtomHeadingPageSectionLanding", LazyAtomHeadingPageSectionLanding],
["AtomIcon", LazyAtomIcon],
["AtomIconArrowDown", LazyAtomIconArrowDown],
["AtomIconArrowLeft", LazyAtomIconArrowLeft],
["AtomIconArrowRight", LazyAtomIconArrowRight],
["AtomIconArrowUp", LazyAtomIconArrowUp],
["AtomIconBasket", LazyAtomIconBasket],
["AtomIconBell", LazyAtomIconBell],
["AtomIconBirthdayCake", LazyAtomIconBirthdayCake],
["AtomIconBookmark", LazyAtomIconBookmark],
["AtomIconBookmarkFilled", LazyAtomIconBookmarkFilled],
["AtomIconCalendar", LazyAtomIconCalendar],
["AtomIconCamera", LazyAtomIconCamera],
["AtomIconCart", LazyAtomIconCart],
["AtomIconCheck", LazyAtomIconCheck],
["AtomIconCheckmark", LazyAtomIconCheckmark],
["AtomIconChevronDown", LazyAtomIconChevronDown],
["AtomIconChevronLeft", LazyAtomIconChevronLeft],
["AtomIconChevronRight", LazyAtomIconChevronRight],
["AtomIconChevronUp", LazyAtomIconChevronUp],
["AtomIconCircledCheck", LazyAtomIconCircledCheck],
["AtomIconCircledCheckFilled", LazyAtomIconCircledCheckFilled],
["AtomIconCircledCrossFilled", LazyAtomIconCircledCrossFilled],
["AtomIconCircledFacebook", LazyAtomIconCircledFacebook],
["AtomIconCircledInstagram", LazyAtomIconCircledInstagram],
["AtomIconCircledSpotify", LazyAtomIconCircledSpotify],
["AtomIconCircledTwitter", LazyAtomIconCircledTwitter],
["AtomIconCircledX", LazyAtomIconCircledX],
["AtomIconCircledYoutube", LazyAtomIconCircledYoutube],
["AtomIconCross", LazyAtomIconCross],
["AtomIconFacebookF", LazyAtomIconFacebookF],
["AtomIconGear", LazyAtomIconGear],
["AtomIconHamburger", LazyAtomIconHamburger],
["AtomIconInstagram", LazyAtomIconInstagram],
["AtomIconMail", LazyAtomIconMail],
["AtomIconMicrophone", LazyAtomIconMicrophone],
["AtomIconMinus", LazyAtomIconMinus],
["AtomIconMusicNote", LazyAtomIconMusicNote],
["AtomIconPdfFile", LazyAtomIconPdfFile],
["AtomIconPencil", LazyAtomIconPencil],
["AtomIconPhone", LazyAtomIconPhone],
["AtomIconPiggyBank", LazyAtomIconPiggyBank],
["AtomIconPile", LazyAtomIconPile],
["AtomIconPlay", LazyAtomIconPlay],
["AtomIconPlus", LazyAtomIconPlus],
["AtomIconPowerSwitch", LazyAtomIconPowerSwitch],
["AtomIconSearch", LazyAtomIconSearch],
["AtomIconShort", LazyAtomIconShort],
["AtomIconTranslate", LazyAtomIconTranslate],
["AtomIconTwitter", LazyAtomIconTwitter],
["AtomIconWhatsApp", LazyAtomIconWhatsApp],
["AtomIconX", LazyAtomIconX],
["AtomIconAppApp", LazyAtomIconAppApp],
["AtomIconAppArchive", LazyAtomIconAppArchive],
["AtomIconAppBullhorn", LazyAtomIconAppBullhorn],
["AtomIconAppCheckboxChecked", LazyAtomIconAppCheckboxChecked],
["AtomIconAppCheckboxUnchecked", LazyAtomIconAppCheckboxUnchecked],
["AtomIconAppCircledExclamationMark", LazyAtomIconAppCircledExclamationMark],
["AtomIconAppClock", LazyAtomIconAppClock],
["AtomIconAppDigital", LazyAtomIconAppDigital],
["AtomIconAppEuro", LazyAtomIconAppEuro],
["AtomIconAppExternal", LazyAtomIconAppExternal],
["AtomIconAppFilter", LazyAtomIconAppFilter],
["AtomIconAppHat", LazyAtomIconAppHat],
["AtomIconAppLoader", LazyAtomIconAppLoader],
["AtomIconAppLocationMarker", LazyAtomIconAppLocationMarker],
["AtomIconAppLock", LazyAtomIconAppLock],
["AtomIconAppPause", LazyAtomIconAppPause],
["AtomIconAppPauseRecommendation", LazyAtomIconAppPauseRecommendation],
["AtomIconAppPerson", LazyAtomIconAppPerson],
["AtomIconAppPlay", LazyAtomIconAppPlay],
["AtomIconAppPlayRecommendation", LazyAtomIconAppPlayRecommendation],
["AtomIconAppPlayTriangle", LazyAtomIconAppPlayTriangle],
["AtomIconAppPreludium", LazyAtomIconAppPreludium],
["AtomIconAppSearch", LazyAtomIconAppSearch],
["AtomIconAppSignpost", LazyAtomIconAppSignpost],
["AtomIconAppSpeaker", LazyAtomIconAppSpeaker],
["AtomIconAppSpeakerMuted", LazyAtomIconAppSpeakerMuted],
["AtomIconAppWebsitevanhetjaarDark", LazyAtomIconAppWebsitevanhetjaarDark],
["AtomIconAppWebsitevanhetjaarLight", LazyAtomIconAppWebsitevanhetjaarLight],
["AtomIconAppYoutube", LazyAtomIconAppYoutube],
["AtomLink", LazyAtomLink],
["AtomLogosAmsterdamsFondsVoorDeKunst", LazyAtomLogosAmsterdamsFondsVoorDeKunst],
["AtomLogosFpk", LazyAtomLogosFpk],
["AtomLogosHetConcertgebouwFonds", LazyAtomLogosHetConcertgebouwFonds],
["AtomLogosVanLanschot", LazyAtomLogosVanLanschot],
["AtomLogosVriendenloterij", LazyAtomLogosVriendenloterij],
["AtomNewsletter", LazyAtomNewsletter],
["DebugDump", LazyDebugDump],
["FormieFieldAgree", LazyFormieFieldAgree],
["FormieFieldCheckboxes", LazyFormieFieldCheckboxes],
["FormieFieldDate", LazyFormieFieldDate],
["FormieFieldDropdown", LazyFormieFieldDropdown],
["FormieFieldEmail", LazyFormieFieldEmail],
["FormieFieldEntries", LazyFormieFieldEntries],
["FormieFieldFileUpload", LazyFormieFieldFileUpload],
["FormieFieldGroup", LazyFormieFieldGroup],
["FormieFieldHeading", LazyFormieFieldHeading],
["FormieFieldHidden", LazyFormieFieldHidden],
["FormieFieldHtml", LazyFormieFieldHtml],
["FormieFieldMultiLineText", LazyFormieFieldMultiLineText],
["FormieFieldName", LazyFormieFieldName],
["FormieFieldNumber", LazyFormieFieldNumber],
["FormieFieldPhone", LazyFormieFieldPhone],
["FormieFieldRadio", LazyFormieFieldRadio],
["FormieFieldRepeater", LazyFormieFieldRepeater],
["FormieFieldSection", LazyFormieFieldSection],
["FormieFieldSingleLineText", LazyFormieFieldSingleLineText],
["FormieForm", LazyFormieForm],
["FormieRows", LazyFormieRows],
["SmoothReflow", LazySmoothReflow],
["VideoBackground", LazyVideoBackground],
["MoleculeABTestWrapper", LazyMoleculeABTestWrapper],
["MoleculeAudioWorks", LazyMoleculeAudioWorks],
["MoleculeAudioWorksV2", LazyMoleculeAudioWorksV2],
["MoleculeButton", LazyMoleculeButton],
["MoleculeButtonBack", LazyMoleculeButtonBack],
["MoleculeButtonBreadcrumbBack", LazyMoleculeButtonBreadcrumbBack],
["MoleculeButtonMobileLyre", LazyMoleculeButtonMobileLyre],
["MoleculeButtonSearchFilter", LazyMoleculeButtonSearchFilter],
["MoleculeButtonShort", LazyMoleculeButtonShort],
["MoleculeButtonToggle", LazyMoleculeButtonToggle],
["MoleculeCardAudioPlayerOverlay", LazyMoleculeCardAudioPlayerOverlay],
["MoleculeCardBanner", LazyMoleculeCardBanner],
["MoleculeCardCollection", LazyMoleculeCardCollection],
["MoleculeCardCover", LazyMoleculeCardCover],
["MoleculeCardDiscoverLandscape", LazyMoleculeCardDiscoverLandscape],
["MoleculeCardDiscoverPortrait", LazyMoleculeCardDiscoverPortrait],
["MoleculeCardEducation", LazyMoleculeCardEducation],
["MoleculeCardEventAndSeries", LazyMoleculeCardEventAndSeries],
["MoleculeCardEventCompact", LazyMoleculeCardEventCompact],
["MoleculeCardEventMedia", LazyMoleculeCardEventMedia],
["MoleculeCardMenuCategory", LazyMoleculeCardMenuCategory],
["MoleculeCardOverview", LazyMoleculeCardOverview],
["MoleculeCardRecommendationQuestion", LazyMoleculeCardRecommendationQuestion],
["MoleculeCardRecommendationSuggestion", LazyMoleculeCardRecommendationSuggestion],
["MoleculeCardResult", LazyMoleculeCardResult],
["MoleculeCardResultInline", LazyMoleculeCardResultInline],
["MoleculeCarousel", LazyMoleculeCarousel],
["MoleculeCarouselVideo", LazyMoleculeCarouselVideo],
["MoleculeCollage", LazyMoleculeCollage],
["MoleculeComponentJoin", LazyMoleculeComponentJoin],
["MoleculeDatepicker", LazyMoleculeDatepicker],
["MoleculeDatepickerLegacy", LazyMoleculeDatepickerLegacy],
["MoleculeDiscoveryCarousel", LazyMoleculeDiscoveryCarousel],
["MoleculeDiscoveryShort", LazyMoleculeDiscoveryShort],
["MoleculeEducationProductionDetailPageBody", LazyMoleculeEducationProductionDetailPageBody],
["MoleculeEducationProductionOrderInfoRow", LazyMoleculeEducationProductionOrderInfoRow],
["MoleculeEducationProductionPageInfoData", LazyMoleculeEducationProductionPageInfoData],
["MoleculeEventDetailOrderButtons", LazyMoleculeEventDetailOrderButtons],
["MoleculeEventDetailPageAdditionalInfoV2", LazyMoleculeEventDetailPageAdditionalInfoV2],
["MoleculeEventDetailPageAudioV2", LazyMoleculeEventDetailPageAudioV2],
["MoleculeEventDetailPageBackButton", LazyMoleculeEventDetailPageBackButton],
["MoleculeEventDetailPageBodyV2", LazyMoleculeEventDetailPageBodyV2],
["MoleculeEventDetailPageDiscover", LazyMoleculeEventDetailPageDiscover],
["MoleculeEventDetailPageHeaderV2", LazyMoleculeEventDetailPageHeaderV2],
["MoleculeEventDetailPageInfoAndTicketsV2", LazyMoleculeEventDetailPageInfoAndTicketsV2],
["MoleculeEventDetailPageInfoData", LazyMoleculeEventDetailPageInfoData],
["MoleculeEventDetailPageInfoDataMobileSticky", LazyMoleculeEventDetailPageInfoDataMobileSticky],
["MoleculeEventDetailPageInfoDataV2", LazyMoleculeEventDetailPageInfoDataV2],
["MoleculeEventDetailPageMedia", LazyMoleculeEventDetailPageMedia],
["MoleculeEventDetailPageNeta", LazyMoleculeEventDetailPageNeta],
["MoleculeEventDetailPageOtherDates", LazyMoleculeEventDetailPageOtherDates],
["MoleculeEventDetailPageSideProgramV2", LazyMoleculeEventDetailPageSideProgramV2],
["MoleculeEventDetailPageTitleV2", LazyMoleculeEventDetailPageTitleV2],
["MoleculeFacet", LazyMoleculeFacet],
["MoleculeFoldoutItem", LazyMoleculeFoldoutItem],
["MoleculeFoldoutList", LazyMoleculeFoldoutList],
["MoleculeInfoPanel", LazyMoleculeInfoPanel],
["MoleculeInputWithIcon", LazyMoleculeInputWithIcon],
["MoleculeMaskVisual", LazyMoleculeMaskVisual],
["MoleculeMatrix", LazyMoleculeMatrix],
["MoleculeMatrixAudio", LazyMoleculeMatrixAudio],
["MoleculeMatrixBanner", LazyMoleculeMatrixBanner],
["MoleculeMatrixCarousel", LazyMoleculeMatrixCarousel],
["MoleculeMatrixCollectionShelf", LazyMoleculeMatrixCollectionShelf],
["MoleculeMatrixCookieDeclaration", LazyMoleculeMatrixCookieDeclaration],
["MoleculeMatrixDiscoveries", LazyMoleculeMatrixDiscoveries],
["MoleculeMatrixDiscoveryShelf", LazyMoleculeMatrixDiscoveryShelf],
["MoleculeMatrixEvents", LazyMoleculeMatrixEvents],
["MoleculeMatrixFoldout", LazyMoleculeMatrixFoldout],
["MoleculeMatrixForm", LazyMoleculeMatrixForm],
["MoleculeMatrixHubspotForm", LazyMoleculeMatrixHubspotForm],
["MoleculeMatrixImage", LazyMoleculeMatrixImage],
["MoleculeMatrixNewsletter", LazyMoleculeMatrixNewsletter],
["MoleculeMatrixOverviewSectionEntries", LazyMoleculeMatrixOverviewSectionEntries],
["MoleculeMatrixSearchEvents", LazyMoleculeMatrixSearchEvents],
["MoleculeMatrixText", LazyMoleculeMatrixText],
["MoleculeMatrixVideo", LazyMoleculeMatrixVideo],
["MoleculeMatrixVriendenLoterijVipCard", LazyMoleculeMatrixVriendenLoterijVipCard],
["MoleculeMatrixWidget", LazyMoleculeMatrixWidget],
["MoleculeNotification", LazyMoleculeNotification],
["MoleculeOverlayMatrix", LazyMoleculeOverlayMatrix],
["MoleculeOverlayPanel", LazyMoleculeOverlayPanel],
["MoleculeOverlayStickyButton", LazyMoleculeOverlayStickyButton],
["MoleculePicture", LazyMoleculePicture],
["MoleculeProgram", LazyMoleculeProgram],
["MoleculeProgramEventDetail", LazyMoleculeProgramEventDetail],
["MoleculeRecaptchaDisclaimer", LazyMoleculeRecaptchaDisclaimer],
["MoleculeRecommendationProgressBar", LazyMoleculeRecommendationProgressBar],
["MoleculeRecommendationQuestion", LazyMoleculeRecommendationQuestion],
["MoleculeShelf", LazyMoleculeShelf],
["MoleculeSkiplink", LazyMoleculeSkiplink],
["MoleculeVideo", LazyMoleculeVideo],
["OrganismControlPanel", LazyOrganismControlPanel],
["OrganismControlPanelFoldout", LazyOrganismControlPanelFoldout],
["OrganismDesktopMenu", LazyOrganismDesktopMenu],
["OrganismFooter", LazyOrganismFooter],
["OrganismHomeBanners", LazyOrganismHomeBanners],
["OrganismHomeDiscovery", LazyOrganismHomeDiscovery],
["OrganismHomeEvents", LazyOrganismHomeEvents],
["OrganismHomeHeader", LazyOrganismHomeHeader],
["OrganismHomeNewsletter", LazyOrganismHomeNewsletter],
["OrganismHomeOverview", LazyOrganismHomeOverview],
["OrganismHomeSearchConcertsControl", LazyOrganismHomeSearchConcertsControl],
["OrganismHomeSearchConcertsV1", LazyOrganismHomeSearchConcertsV1],
["OrganismLoaderFromUri", LazyOrganismLoaderFromUri],
["OrganismMobileMenu", LazyOrganismMobileMenu],
["OrganismModal", LazyOrganismModal],
["OrganismOverviewHeaderAndFiltersControl", LazyOrganismOverviewHeaderAndFiltersControl],
["OrganismOverviewHeaderAndFiltersV1", LazyOrganismOverviewHeaderAndFiltersV1],
["OrganismPageOverlay", LazyOrganismPageOverlay],
["OrganismPageSectionContent", LazyOrganismPageSectionContent],
["OrganismPagination", LazyOrganismPagination],
["OrganismPaginationV2", LazyOrganismPaginationV2],
["OrganismRecommendationLoadingPage", LazyOrganismRecommendationLoadingPage],
["OrganismRecommendationQuestionnaire", LazyOrganismRecommendationQuestionnaire],
["OrganismRecommendationRestartBlock", LazyOrganismRecommendationRestartBlock],
["OrganismRecommendationStartPage", LazyOrganismRecommendationStartPage],
["OrganismRecommendationSuggestMailBlock", LazyOrganismRecommendationSuggestMailBlock],
["OrganismRecommendationSuggestSidebar", LazyOrganismRecommendationSuggestSidebar],
["OrganismRecommendationSuggestTopEvents", LazyOrganismRecommendationSuggestTopEvents],
["OrganismRecommendationSuggestionBottomEvents", LazyOrganismRecommendationSuggestionBottomEvents],
["OrganismRecommendationSuggestionPage", LazyOrganismRecommendationSuggestionPage],
["OrganismSearchHeader", LazyOrganismSearchHeader],
["OrganismTixState", LazyOrganismTixState],
["TemplateBase", LazyTemplateBase],
["TemplateCampaignDetail", LazyTemplateCampaignDetail],
["TemplateDiscoveryCollectionDetail", LazyTemplateDiscoveryCollectionDetail],
["TemplateDiscoveryDetail", LazyTemplateDiscoveryDetail],
["TemplateDiscoveryOverview", LazyTemplateDiscoveryOverview],
["TemplateDiscoverySearchOverview", LazyTemplateDiscoverySearchOverview],
["TemplateEducationOverview", LazyTemplateEducationOverview],
["TemplateEducationProductionDetail", LazyTemplateEducationProductionDetail],
["TemplateEducationProductionOverview", LazyTemplateEducationProductionOverview],
["TemplateEducationUserUpdateForm", LazyTemplateEducationUserUpdateForm],
["TemplateError", LazyTemplateError],
["TemplateEventDetailV2", LazyTemplateEventDetailV2],
["TemplateEventOverview", LazyTemplateEventOverview],
["TemplateFavoritePage", LazyTemplateFavoritePage],
["TemplateHome", LazyTemplateHome],
["TemplateOverview", LazyTemplateOverview],
["TemplatePageDetail", LazyTemplatePageDetail],
["TemplatePressDetail", LazyTemplatePressDetail],
["TemplatePressOverview", LazyTemplatePressOverview],
["TemplateRecommendationDetail", LazyTemplateRecommendationDetail],
["TemplateRecommendationDetailV2", LazyTemplateRecommendationDetailV2],
["TemplateSearch", LazyTemplateSearch],
["TemplateSeriesDetail", LazyTemplateSeriesDetail],
["TemplateSeriesOverview", LazyTemplateSeriesOverview],
["TemplateUnknownPage", LazyTemplateUnknownPage],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
